import { Injectable } from '@angular/core';

import { Observable, of, Subject } from 'rxjs';
import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';
import { POLAuthService } from 'src/app/core/services/auth.service';
import { switchMap, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SignOutGuard {

  constructor(
    private auth: OidcClientService,
    private authService: POLAuthService
  ) { }

  canActivate(): Observable<boolean> {
    const unsubscribe = new Subject();
    return this.auth.getUserComputed().pipe(
      takeUntil(unsubscribe),
      switchMap(userComputed => {
        console.log('signOutGuard user', userComputed);
        if (userComputed) {
          sessionStorage.clear();
          console.log('signOutGuard user exists - returning false and initiate sign out.');
          this.authService.signOutRedirect({ signOut: true });
          return of(false);
        } else {
          // Completes signoutPopup() promise from authService.signOut()
          this.auth.userManager.signoutPopupCallback();
          console.log('signOutGuard no user - returning true.');
          return of(true);
        }
      })
    )
  }
}
